import {AppPage} from "common/Layout";
import {AppButton} from "shared/UI/UIKit/Button";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {AppImage} from "shared/UI/UIKit/Image";
import type {TheoryPage as TheoryPageType} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import {PageType} from "../../config/types";
import styles from "./styles.module.scss";

export const TheoryPage = () => {
  const theoryPage = GLOBAL_CONFIG.pages.find(page => page.type === PageType.THEORY) as TheoryPageType;

  if (!theoryPage) {
    return null;
  }

  const downloadPdf = () => {
    const newWin = window.open("");
    newWin!.location.href = theoryPage.pdfPath;
  };

  return (
    <AppPage contentClassName={styles.content} pageTitle="Аннотация" documentTitle="Аннотация">
      <AppButton onClick={downloadPdf} className={styles.pdf}>Скачать PDF</AppButton>
      <AppFlex unit="30">
        <AppText size={24} className={styles.title}>Теория</AppText>
        <div>
          {
            theoryPage.content.map((item, index) => {
              switch (item.type) {
                case "block":
                  return (
                    <div key={index} className={styles.block}>
                      <AppText size={18}>
                        {item.text}
                      </AppText>
                    </div>
                  );
                case "text":
                  return (
                    <div key={index} className={styles.paragraph}>
                      <AppText size={18}>
                        {item.text}
                      </AppText>
                    </div>
                  );
                case "image":
                  return (
                    <AppImage key={index} src={item.imagePath} alt="image" className={styles.image}/>
                  );
                default:
                  return null;
              }
            })
          }
        </div>
      </AppFlex>
    </AppPage>
  );
};
